import { DEX_TYPE } from "@/config/constants";
import { DEX_LOCALE } from "@/constants/configuration/dex-locale/dex-locale";

export const fetchDexText = (dexType, textType) => {
    return DEX_LOCALE[dexType]?.[textType] || DEX_LOCALE[DEX_TYPE.SGTRADEX][textType];
}